<div class="p-grid">
	<ng-container *ngFor="let ooVenue of ooVenueList">
		<div class="p-col-12 p-md-4">
			<div class="m-2 h-100">
				<app-venue-listing [ooVenue]="ooVenue"></app-venue-listing>
			</div>
		</div>
	</ng-container>
</div>
